<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 24">
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <path
        id="a"
        d="M19 9c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2H2v2h14.185A2.993 2.993 0 0 0 19 9zm0 6c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.994 2.994 0 0 1-2.815-2H2v-2h14.185A2.993 2.993 0 0 1 19 15zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 9c1.302 0 2.401.838 2.815 2H22v2H11.815A2.994 2.994 0 0 1 9 15a2.994 2.994 0 0 1-2.815-2H2v-2h4.185A2.993 2.993 0 0 1 9 9zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10-6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "settings",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
